export default __webpack_public_path__ + "static/media/av.4b00b558.jpg";